<template>
  <ul
    class="search-categories-list"
    :class="{ 'search-categories-list--main': isMain }"
  >
    <li v-for="(item, i) in list" :key="i">
      <a
        @mouseenter="$emit('setActive', item)"
        @click.prevent="openCategoryPage(item)"
        class="search-categories-item"
        :class="{ 'search-categories-item--active': isActive(item) }"
        href="#"
      >
        <icon
          v-if="item.icon"
          class="search-categories-item-icon"
          :name="item.icon"
          width="20"
          height="20"
        />
        <span class="search-categories-item-title">
          {{ item | localeField("name") }}
        </span>
        <icon class="search-categories-item-arrow" name="arrow-drop-right" />
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "ServicesCategoriesList",
  props: {
    list: Array,
    actives: Array,
    isMain: Boolean
  },
  methods: {
    async openCategoryPage(data) {
      await this.$router.push({
        name: "category",
        params: { id: this.$route.params.id, category_id: data.id }
      });
      this.$store.state.event._overlays.servicesCategories = false;
    },
    isActive(item) {
      return !!this.actives.find(
        i => JSON.stringify(i) === JSON.stringify(item.children)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.search-categories {
  &-list {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 323.5px;
    border-right: 1px solid var(--gray-darker, #d5dae5);

    &--main {
      width: 292px;
      flex-shrink: 0;
      background: var(--main-bg, #f0f5f9);

      .search-categories-item {
        &--active,
        &:hover {
          background: var(--white, #fff);
        }
      }
    }
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    text-decoration: none;
    color: var(--dark, #262626);
    font-size: 0.875rem;
    line-height: 22px;

    &--active,
    &:hover {
      color: var(--main-dark, #005197);
      background: var(--main-bg, #f0f5f9);
    }

    &-title {
      flex-grow: 1;
    }

    &-icon {
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      padding: 5px;
      margin-right: 5px;
    }

    &-arrow {
      flex-shrink: 0;
      margin-left: 5px;
      width: 14px;
      height: 14px;
    }
  }
}
</style>
